import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type SectionHeadProps = {
  title: string
  subtitle?: string
  right?: ReactNode
  className?: string
  /** Heading level inside nested sections; default h2 keeps existing pages unchanged. */
  level?: 2 | 3 | 4
}

export function SectionHead({ title, subtitle, right, className, level = 2 }: SectionHeadProps) {
  const Heading = `h${level}` as const
  return (
    <div className={cn('mb-3 flex items-end justify-between gap-4', className)}>
      <div>
        <Heading className="text-[15px] font-bold tracking-tight text-[var(--foreground)]">
          {title}
        </Heading>
        {subtitle && (
          <p className="mt-0.5 text-xs text-[var(--muted-foreground)]">{subtitle}</p>
        )}
      </div>
      {right}
    </div>
  )
}

export default SectionHead
